/**
 * Check if user has Pro tier or higher
 * @param {Object} user - User object with tier property
 * @returns {boolean} - True if user is Pro or higher
 */
export const isProOrHigher = (user) => {
  if (!user || !user.tier) return false;
  const tier = user.tier.toLowerCase();
  return tier === 'pro' || tier === 'premium' || tier === 'enterprise';
};

/**
 * Check if user is on basic tier (not free, not pro+)
 * @param {Object} user - User object with tier property
 * @returns {boolean} - True if user is on basic tier
 */
export const isBasic = (user) => {
  if (!user || !user.tier) return false;
  const tier = user.tier.toLowerCase();
  return tier === 'basic';
};
